import {create} from "zustand";

const useGatePassConfigurationStore = create((set) => ({
    isGatePassConfigurationAdded: false,
    isGatePassConfigurationStatusUpdated: false,
    isGatePassConfigurationDeleted: false,

    setGatePassConfigurationAdded: (status) => set({isGatePassConfigurationAdded: status}),
    setGatePassConfigurationStatusUpdated: (status) => set({isGatePassConfigurationStatusUpdated: status}),
    setGatePassConfigurationDeleted: (status) => set({isGatePassConfigurationDeleted: status}),
}));

export default useGatePassConfigurationStore